// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__31OI7","Title":"Modal_Title__2uQ4K","Body":"Modal_Body__3GJkG"};